import React, { ReactElement, useCallback } from 'react';
import classNames from 'classnames';
import { Pagination } from 'b2b-apps/shop/common/components/Pagination';
import { NEWSROOM_ASSETS_PAGE_SIZE } from 'b2b-apps/shop/content/redux/newsroom/sagas';
import { NewsroomAssetsType } from 'b2b-common/core/content/api/Newsroom.types';
import { Asset } from './Asset';
import { ComponentType, Props } from './';

const NewsroomAssets: ComponentType = ({
  className,
  newsData,
  onPaginationPageChange,
  page,
}: Props): ReactElement | null => {
  const renderPagination = useCallback(
    (newsData: NewsroomAssetsType | null): ReactElement | null => {
      if (newsData) {
        return (
          <Pagination
            total={Math.ceil(newsData.total / NEWSROOM_ASSETS_PAGE_SIZE)}
            page={page || 1}
            onPageChange={onPaginationPageChange}
          />
        );
      }

      return null;
    },
    [
      page,
      onPaginationPageChange,
    ],
  );

  if (!newsData || !newsData.assets || !Array.isArray(newsData.assets) || !newsData.assets.length) {
    return null;
  }

  return (
    <div className={classNames('cds-cms-NewsroomAssets', className)}>
      <div className="row">
        {
          newsData.assets.map(asset => (
            <Asset
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12"
              fileName={asset.fileName}
              key={asset.uid}
              thumbnail={asset.thumbnail}
              url={asset.url}
            />
          ))
        }
      </div>
      {renderPagination(newsData)}
    </div>
  );
};

export { NewsroomAssets };
